import { render } from '@react-email/render'
import React, { useState, useEffect, useRef } from 'react'
import { data, useFetcher } from 'react-router'
import {
	Page,
	PageTopBarBackButtonLink,
	PageTopBarHeading,
} from '#app/components/pageSetup/page.tsx'
import {
	ForgotPasswordEmail,
	VerificationCodeEmail,
	EmailChangeEmail,
	EmailChangeNoticeEmail,
	WelcomeEmail,
	AppUpdateEmail,
} from '#app/routes/_emails/emails.tsx'

const templates = {
	ForgotPasswordEmail,
	VerificationCodeEmail,
	EmailChangeEmail,
	EmailChangeNoticeEmail,
	WelcomeEmail,
	AppUpdateEmail,
}

type TemplateName = keyof typeof templates

export function loader() {
	const templates2 = Object.keys(templates)

	console.log(templates2)

	return data({ templates: templates2 })
}

export async function action({ request }: { request: Request }) {
	const formData = await request.formData()
	const templateName = formData.get('templateName') as TemplateName

	console.log(templateName)

	const TemplateComponent = templates[templateName]
	const emailHtml = await render(
		<TemplateComponent
			onboardingUrl={'https://example.com/onboard'}
			otp={'123456'}
			verifyUrl={'https://example.com/verify'}
			userId={'user_123'}
			version={'1.2.3'}
			title={'Update Available'}
			description={'A new version is ready!'}
		/>,
	)

	return data({ emailHtml })
}

export default function EmailTemplatePage() {
	const fetcher = useFetcher()
	const [selectedTemplate, setSelectedTemplate] = useState<TemplateName | null>(
		null,
	)
	const [htmlContent, setHtmlContent] = useState<string | null>(null)
	const iframeRef = useRef<HTMLIFrameElement>(null)

	const handleSelectChange = async (
		event: React.ChangeEvent<HTMLSelectElement>,
	) => {
		const templateName = event.target.value as TemplateName | ''
		if (templateName) {
			setSelectedTemplate(templateName)
			void fetcher.submit(
				{
					templateName,
				},
				{
					method: 'POST',
					action: '/admin/emails',
				},
			)
		} else {
			setSelectedTemplate(null)
			setHtmlContent(null)
		}
	}

	useEffect(() => {
		const iframe = iframeRef.current
		if (!iframe || !htmlContent) return

		const handleLoad = () => {
			if (iframe.contentWindow) {
				const body = iframe.contentWindow.document.body
				const html = iframe.contentWindow.document.documentElement
				const height = Math.max(
					body.scrollHeight,
					body.offsetHeight,
					html.clientHeight,
					html.scrollHeight,
					html.offsetHeight,
				)
				iframe.style.height = `${height + 20}px` // Add some padding
			}
		}

		// Set srcDoc and add load listener
		iframe.srcdoc = htmlContent
		iframe.addEventListener('load', handleLoad)

		// Cleanup
		return () => {
			iframe.removeEventListener('load', handleLoad)
		}
	}, [htmlContent])

	const handleBack = () => {
		setSelectedTemplate(null)
		setHtmlContent(null)
	}

	return (
		<Page
			topBar={{
				heading: (
					<PageTopBarHeading heading={'Email Templates'} icon="envelope-open" />
				),
				actions: <PageTopBarBackButtonLink to="/admin/dashboard" />,
			}}
		>
			<div className="p-4">
				<div className="mb-4 flex items-center gap-4">
					<select
						value={selectedTemplate ?? ''}
						onChange={handleSelectChange}
						className="rounded border p-2"
					>
						<option value="">Select an email template</option>
						{Object.keys(templates).map((templateName) => (
							<option key={templateName} value={templateName}>
								{templateName}
							</option>
						))}
					</select>
					{selectedTemplate && (
						<button
							onClick={handleBack}
							className="rounded bg-gray-200 p-2 hover:bg-gray-300"
						>
							Clear Preview
						</button>
					)}
				</div>

				<div className="flex h-[70vh] items-center justify-center rounded border p-4">
					<iframe
						srcDoc={fetcher.data?.emailHtml}
						title="Email Preview"
						style={{ width: '100%', height: '100%', border: 'none' }}
					/>
				</div>
			</div>
		</Page>
	)
}
